import FacturaShow from './FacturaShow'
export {FacturaShow}
export default FacturaShow
